import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui';
import { images } from '../../config/colors';
import tocBackgroundFallback from '../../assets/tocBackground.jpg';
import styles from './ShareCoinsPage.module.css';
import type { Account } from '../../api/event';
import type { EventData } from '../../api/event';

const tocBackground = images.background || tocBackgroundFallback;

interface LocationState {
  account?: Account;
  event?: EventData;
  maxCoins?: number;
}

export function ShareCoinsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { account, event, maxCoins = 0 } = (location.state as LocationState) || {};

  return (
    <div
      className={styles.background}
      style={{ backgroundImage: `url(${tocBackground})` }}
    >
      <div className={styles.container}>
        <p className={styles.title}>Share Coins</p>
        <div className={styles.buttonGroup}>
          <Button
            onClick={() => navigate('/give-coins', { state: { account, event, maxCoins } })}
            disabled={maxCoins <= 0}
          >
            Give Coins
          </Button>
          <Button
            theme="secondary"
            onClick={() => navigate('/receive-coins', { state: { account } })}
          >
            Receive Coins
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ShareCoinsPage;
